import VueCroppie from '@/mixins/VueCroppieComponent.js'

export default {
  props       : ['croppieRef'],

  components  : {
    VueCroppie
  },

  data(){
    return {
      croppieOptions : {
        enableOrientation : true,
        enableResize      : false,
        enableZoom        : true,
        showZoomer        : false,
        viewport          : {
          width     : 270,
          height    : 270,
          type      : 'circle'
        },
        boundary          : {
          width     : 280,
          height    : 280
        },
      },

      croppieCropped  : null,

      imageFile      : null,
    };
  },

  watch : {
    imageFile(value){
      if(value === null) return;

      const vm      = this;
      const reader  = new FileReader();

      reader.onload = (event) => {
        vm.$refs.croppieRef.bind({
          url : event.target.result,
        });
      };

      reader.readAsDataURL(value);
    }
  },
  
  methods : {
    croppieGetResultBase64(){
      return new Promise((resolve) => {
        const options = {
          format  : 'png',
          type    : 'base64',
          circle  : false,
        };

        this.$refs.croppieRef.result(options, (output) => {
          resolve(output);
        });
      });
    },

    croppieCropViaEvent(){
      this.$refs.croppieRef.result({
        format  : 'png',
        circle  : false,
      });
    },

    croppieRotate(angle){
      this.$refs.croppieRef.rotate(angle);
    },

    croppieResultEvent(output){
      this.croppieCropped = output;
    }
  }
};
